import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Button from '../../../Components/Button'
import './BDHeader.scss'
import PageModes from './PageModes'

export default class BDHeader extends Component {
    render() {
        return (
            <div className='bd-header'>
                <span className="bd-header__title">{this.props.title}</span>

                <Actions {...this.props} />
            </div>
        )
    }
}

const Actions = (props) => {

    const MODE = props.mode;

    switch (MODE) {
        case PageModes.NEW:
            return (
                <div className="bd-header__actions">
                    <Link to={`${props.to}`}>
                        <Button>Back</Button>
                    </Link>
                    <Button variant={'success'} onClick={props.onClickSave}>Save</Button>
                    <Button variant={'danger'} onClick={props.onClickReset}>Reset</Button>
                </div>
            )
        case PageModes.VIEW:
            return (
                <div className="bd-header__actions">
                    <Link to={`${props.to}/new`}>
                        <Button>New</Button>
                    </Link>
                </div>
            )
        case PageModes.EDIT:
            return (
                <div className="bd-header__actions">
                    <Link to={`${props.to}/new`}>
                        <Button>New</Button>
                    </Link>
                </div>
            )
        case PageModes.DELETE:
            return (
                <div className="bd-header__actions">
                    <Link to={`${props.to}/new`}>
                        <Button>New</Button>
                    </Link>
                </div>
            )
        case PageModes.GRID:
            return (
                <div className="bd-header__actions">
                    <Link to={`${props.to}/new`}>
                        <Button>New</Button>
                    </Link>
                </div>
            )
        default: return null;
    }
}
